import type { RouteObject } from "react-router-dom";

export const conversionMonitorRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Conversion Monitor" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { LongTermConversionMonitorPage } = await import(
            "./long-term-conversion-monitor-page"
          );
          return { Component: LongTermConversionMonitorPage };
        },
      },
    ],
  },
];
